export const AICategorisedManually = ({ size = "32" }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12.0001"
        cy="12"
        r="10"
        fill="currentColor"
        fill-opacity="0.5"
      />
      <circle
        cx="12.0001"
        cy="12"
        r="10"
        fill="url(#paint0_linear_6400_8979)"
      />
      <g clip-path="url(#clip0_6400_8979)">
        <path
          d="M9.9375 13.5C11.2837 13.5 12.375 12.4087 12.375 11.0625C12.375 9.71631 11.2837 8.625 9.9375 8.625C8.59131 8.625 7.5 9.71631 7.5 11.0625C7.5 12.4087 8.59131 13.5 9.9375 13.5Z"
          stroke="white"
          stroke-width="0.84"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.47937 15.375C6.85394 14.7991 7.36643 14.3258 7.97031 13.9982C8.57418 13.6706 9.25032 13.499 9.93734 13.499C10.6244 13.499 11.3005 13.6706 11.9044 13.9982C12.5082 14.3258 13.0207 14.7991 13.3953 15.375"
          stroke="white"
          stroke-width="0.84"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.0625 13.5C14.7495 13.4996 15.4257 13.6709 16.0296 13.9984C16.6335 14.3258 17.146 14.7991 17.5205 15.375"
          stroke="white"
          stroke-width="0.84"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.1583 8.79844C13.4918 8.66545 13.8504 8.60775 14.2088 8.62946C14.5671 8.65117 14.9162 8.75176 15.2311 8.92403C15.546 9.0963 15.819 9.33601 16.0306 9.62602C16.2421 9.91603 16.387 10.2492 16.4549 10.6017C16.5227 10.9542 16.5119 11.3173 16.4232 11.6652C16.3344 12.013 16.1699 12.3369 15.9415 12.6138C15.713 12.8907 15.4262 13.1137 15.1016 13.2669C14.7769 13.4201 14.4225 13.4997 14.0635 13.5"
          stroke="white"
          stroke-width="0.84"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6400_8979"
          x1="12.0518"
          y1="2"
          x2="22.8269"
          y2="8.62105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B29BFF" />
          <stop offset="1" stop-color="#8064DE" />
        </linearGradient>
        <clipPath id="clip0_6400_8979">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
